import { DateTime } from 'luxon';

export function isStringValidDateTime(time: string) {
  return DateTime.fromISO(time).isValid;
}
